import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSEO, buildBreadcrumbSchema } from "@/hooks/useSEO";

const articles = [
  {
    slug: "o-que-e-cssbuy-spreadsheet",
    title: "O que é CSSBuy Spreadsheet e como funciona",
    excerpt: "Descubra o que é CSSBuy Spreadsheet, como esta ferramenta revolucionou as compras internacionais e por que milhares de utilizadores confiam nela diariamente para organizar os seus pedidos da China.",
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20ecommerce%20spreadsheet%20concept%20with%20warm%20terracotta%20tones%2C%20product%20photos%20arranged%20on%20clean%20desk%2C%20soft%20natural%20lighting%2C%20Scandinavian%20editorial%20style%2C%20simple%20composition%2C%20aesthetic%20flat%20lay%20with%20laptop%20and%20fashion%20items%20on%20cream%20background&width=800&height=500&seq=blog-card-01-v4&orientation=landscape",
    date: "15 Junho 2026",
    readTime: "8 min",
  },
  {
    slug: "como-usar-cssbuy-spreadsheet-passo-a-passo",
    title: "Como usar CSSBuy Spreadsheet passo a passo",
    excerpt: "Guia prático completo para iniciantes: aprenda a navegar, selecionar produtos e fazer os seus pedidos com a CSSBuy Spreadsheet sem complicações nem erros.",
    image: "https://readdy.ai/api/search-image?query=Step%20by%20step%20tutorial%20concept%2C%20hands%20typing%20on%20laptop%20with%20notebook%20nearby%2C%20warm%20sage%20green%20and%20cream%20tones%2C%20minimalist%20workspace%2C%20soft%20morning%20light%2C%20clean%20Scandinavian%20desk%20setup%2C%20editorial%20photography%20style&width=800&height=500&seq=blog-card-02-v4&orientation=landscape",
    date: "14 Junho 2026",
    readTime: "10 min",
  },
  {
    slug: "cssbuy-spreadsheet-e-confiavel",
    title: "CSSBuy Spreadsheet é confiável? Análise completa",
    excerpt: "Análise detalhada sobre a segurança, fiabilidade e reputação da CSSBuy Spreadsheet. Saiba se pode confiar os seus dados e compras a esta plataforma.",
    image: "https://readdy.ai/api/search-image?query=Security%20shield%20concept%20on%20minimalist%20desk%2C%20warm%20terracotta%20and%20beige%20tones%2C%20trust%20symbolism%2C%20lock%20icon%20with%20soft%20shadows%2C%20clean%20workspace%20aesthetic%2C%20editorial%20product%20photography%20with%20natural%20diffused%20lighting&width=800&height=500&seq=blog-card-03-v4&orientation=landscape",
    date: "13 Junho 2026",
    readTime: "7 min",
  },
  {
    slug: "melhor-cssbuy-spreadsheet-2026",
    title: "Melhor CSSBuy Spreadsheet 2026: Guia de escolha",
    excerpt: "Comparação completa das melhores opções de CSSBuy Spreadsheet disponíveis em 2026. Descubra qual se adapta melhor ao seu perfil de comprador e orçamento.",
    image: "https://readdy.ai/api/search-image?query=Trophy%20and%20comparison%20charts%20on%20minimalist%20desk%2C%20warm%20golden%20amber%20and%20cream%20tones%2C%20ranking%20concept%2C%20clean%20workspace%20with%20award%20symbolism%2C%20soft%20natural%20light%2C%20editorial%20style%20photography%20with%20elegant%20composition&width=800&height=500&seq=blog-card-04-v4&orientation=landscape",
    date: "12 Junho 2026",
    readTime: "9 min",
  },
  {
    slug: "cssbuy-vs-pandabuy-vs-sugargoo",
    title: "CSSBuy vs Pandabuy vs Sugargoo: Comparação 2026",
    excerpt: "Análise objetiva dos três maiores agentes de compras da China. Compare taxas, velocidades de envio, segurança e experiência do utilizador para decidir qual é o melhor.",
    image: "https://readdy.ai/api/search-image?query=Three%20shopping%20bags%20side%20by%20side%20comparison%20concept%2C%20warm%20terracotta%20and%20sage%20tones%2C%20minimalist%20product%20photography%2C%20soft%20lighting%20on%20cream%20background%2C%20clean%20editorial%20style%2C%20consumer%20choice%20symbolism&width=800&height=500&seq=blog-card-05-v4&orientation=landscape",
    date: "11 Junho 2026",
    readTime: "11 min",
  },
  {
    slug: "como-encontrar-produtos-cssbuy-spreadsheet",
    title: "Como encontrar produtos no CSSBuy Spreadsheet",
    excerpt: "Técnicas e estratégias avançadas para localizar exatamente o que procura dentro da CSSBuy Spreadsheet. Domine os filtros e pesquisas para poupar horas.",
    image: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20product%20catalog%20concept%2C%20warm%20beige%20and%20terracotta%20tones%2C%20search%20symbolism%20on%20minimalist%20desk%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography%2C%20discovery%20theme%20with%20elegant%20composition&width=800&height=500&seq=blog-card-06-v4&orientation=landscape",
    date: "10 Junho 2026",
    readTime: "8 min",
  },
  {
    slug: "erros-comuns-cssbuy-spreadsheet",
    title: "Erros comuns ao usar CSSBuy Spreadsheet",
    excerpt: "Evite os 10 erros mais frequentes que os iniciantes cometem. Poupe dinheiro, tempo e frustrações com este guia prático de prevenção de erros.",
    image: "https://readdy.ai/api/search-image?query=Warning%20signs%20and%20correction%20marks%20on%20paper%20concept%2C%20warm%20amber%20and%20cream%20tones%2C%20mistake%20prevention%20symbolism%2C%20minimalist%20desk%20with%20red%20pen%20marks%2C%20soft%20diffused%20lighting%2C%20editorial%20style%20with%20clean%20composition&width=800&height=500&seq=blog-card-07-v4&orientation=landscape",
    date: "9 Junho 2026",
    readTime: "7 min",
  },
  {
    slug: "guia-completo-cssbuy-iniciantes",
    title: "Guia completo CSSBuy para iniciantes 2026",
    excerpt: "Tudo o que um iniciante precisa de saber sobre CSSBuy: desde criar conta até receber a primeira encomenda. O guia mais completo em português.",
    image: "https://readdy.ai/api/search-image?query=Beginner%20guide%20book%20on%20minimalist%20desk%2C%20warm%20terracotta%20and%20sage%20green%20tones%2C%20learning%20concept%2C%20open%20notebook%20with%20highlights%2C%20soft%20morning%20light%2C%20clean%20Scandinavian%20editorial%20photography%20style%20with%20natural%20textures&width=800&height=500&seq=blog-card-08-v4&orientation=landscape",
    date: "8 Junho 2026",
    readTime: "12 min",
  },
  {
    slug: "como-economizar-cssbuy-spreadsheet",
    title: "Como economizar dinheiro com CSSBuy Spreadsheet",
    excerpt: "Estratégias comprovadas para reduzir os seus custos de compra em até 40%. Dicas de envio, consolidação de encomendas e escolha de agentes mais baratos.",
    image: "https://readdy.ai/api/search-image?query=Piggy%20bank%20and%20coins%20on%20minimalist%20desk%2C%20warm%20golden%20and%20cream%20tones%2C%20savings%20concept%2C%20soft%20natural%20lighting%2C%20financial%20planning%20symbolism%2C%20clean%20editorial%20photography%20with%20elegant%20simple%20composition&width=800&height=500&seq=blog-card-09-v4&orientation=landscape",
    date: "7 Junho 2026",
    readTime: "9 min",
  },
  {
    slug: "cssbuy-spreadsheet-funciona-para-roupas",
    title: "CSSBuy Spreadsheet funciona para roupas?",
    excerpt: "Guia específico para compradores de moda: como usar a CSSBuy Spreadsheet para encontrar as melhores réplicas, tamanhos certos e evitar devoluções.",
    image: "https://readdy.ai/api/search-image?query=Fashion%20clothing%20items%20arranged%20on%20minimalist%20desk%2C%20warm%20terracotta%20and%20beige%20tones%2C%20apparel%20shopping%20concept%2C%20folded%20garments%20with%20soft%20shadows%2C%20natural%20diffused%20lighting%2C%20editorial%20style%20photography%20with%20clean%20aesthetic%20composition&width=800&height=500&seq=blog-card-10-v4&orientation=landscape",
    date: "6 Junho 2026",
    readTime: "8 min",
  },
];

export default function BlogPage() {
  useSEO({
    title: "Blog CSSBuy Spreadsheet — Guias, Tutoriais e Comparações de Compras da China",
    description: "Acesse todos os artigos e guias completos sobre CSSBuy Spreadsheet. Tutoriais passo a passo, comparações de agentes, dicas de economia e segurança para compras internacionais da China.",
    keywords: "blog cssbuy spreadsheet, cssbuy artigos, cssbuy tutoriais, guia cssbuy, comparacao agentes china",
    canonicalPath: "/blog",
    ogType: "website",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "Blog CSSBuy Spreadsheet",
        description: "Coleção de artigos, guias e tutoriais sobre CSSBuy Spreadsheet para compras internacionais da China.",
        url: "https://cssbuyspreadsheet.delivery/blog",
        inLanguage: "pt-BR",
      },
      buildBreadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Blog", path: "/blog" },
      ]),
    ],
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-accent-100/30 via-background-50 to-background-50"></div>
        <div className="relative max-w-7xl mx-auto px-4 md:px-10 text-center">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-4">
            Blog CSSBuy Spreadsheet
          </h1>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Guias completos, comparações e tutoriais para dominar as compras internacionais com a CSSBuy Spreadsheet. Conteúdo 100% original em português.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-10 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-accent-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                <div className="absolute bottom-3 left-4 flex items-center gap-3">
                  <span className="text-xs text-background-50/90 bg-foreground-900/50 backdrop-blur-sm px-3 py-1 rounded-full">
                    {article.date}
                  </span>
                  <span className="text-xs text-background-50/90 bg-foreground-900/50 backdrop-blur-sm px-3 py-1 rounded-full">
                    {article.readTime} de leitura
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h2 className="font-heading text-lg font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors leading-snug mb-3">
                  {article.title}
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-2 text-sm text-accent-600 font-medium">
                  Ler artigo
                  <i className="ri-arrow-right-line text-sm transition-transform duration-200 group-hover:translate-x-1"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-300 text-foreground-700 text-sm font-medium hover:border-foreground-900 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            Voltar para a Página Inicial
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}